import React, { useState, useRef, useEffect } from "react";

const MultiSelectDropdown = ({
  options = [],
  selectedValues = [],
  onSelect,
  placeholder = "Select options",
  selectAllText = "Select All",
  deselectAllText = "Deselect All",
  showSelectAll = true,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(selectedValues);
  const dropdownRef = useRef(null);

  // Update internal state when selectedValues prop changes
  useEffect(() => {
    setSelected(selectedValues);
  }, [selectedValues]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (value) => {
    let newSelected;
    if (selected.includes(value)) {
      newSelected = selected.filter((v) => v !== value);
    } else {
      newSelected = [...selected, value];
    }
    setSelected(newSelected);
    if (onSelect) {
      onSelect(newSelected);
    }
  };

  const handleSelectAll = () => {
    const allValues = options.map((o) => o.id);
    setSelected(allValues);
    if (onSelect) {
      onSelect(allValues);
    }
  };

  const handleDeselectAll = () => {
    setSelected([]);
    if (onSelect) {
      onSelect([]);
    }
  };

  const getDisplayText = () => {
    if (selected.length === 0) {
      return placeholder;
    } else {
      return `${selected.length} selected`;
    }
  };

  return (
    <div className="dropdown w-100" ref={dropdownRef}>
      <button
        className={`btn btn-outline-secondary dropdown-toggle text-start w-100 ${
          disabled ? "disabled" : ""
        }`}
        type="button"
        onClick={toggleDropdown}
        disabled={disabled}
        aria-expanded={isOpen}
      >
        {getDisplayText()}
      </button>

      <ul
        className={`dropdown-menu ${isOpen ? "show" : ""}`}
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          width: "100%",
          marginTop: "2px",
        }}
      >
        {showSelectAll && options.length > 0 && (
          <>
            <li>
              <button className="dropdown-item" onClick={handleSelectAll}>
                {selectAllText}
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={handleDeselectAll}>
                {deselectAllText}
              </button>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </>
        )}

        {options.map((option) => (
          <li key={option.id}>
            <label className="dropdown-item d-flex align-items-center">
              <input
                type="checkbox"
                checked={selected.includes(option.id)}
                onChange={() => handleOptionClick(option.id)}
                className="form-check-input me-2"
              />
              {option.campus_name}
            </label>
          </li>
        ))}

        {options.length === 0 && (
          <li>
            <span className="dropdown-item text-muted">
              No options available
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default MultiSelectDropdown;
